module.exports = __webpack_public_path__ + "img/icon-wifi-01-1.c4c4f56a.svg";